import React, { useEffect } from 'react';

const Toast = ({ open, message, type = 'success', onClose, duration = 2500 }) => {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => onClose?.(), duration);
    return () => clearTimeout(t);
  }, [open, duration, onClose]);

  if (!open) return null;

  const color = type === 'success' ? 'bg-success text-success-foreground' :
                type === 'error' ? 'bg-error text-error-foreground' :
                'bg-muted text-foreground';

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className={`px-4 py-3 rounded-md shadow-moderate border border-border ${color}`}>
        <div className="flex items-center space-x-2">
          <span className="text-sm">{message}</span>
          <button onClick={onClose} className="text-sm underline">Close</button>
        </div>
      </div>
    </div>
  );
};

export default Toast;

